import * as MyEarcut from "earcut";
import { Color3 } from "@babylonjs/core/Maths/math.color";
import { Mesh } from "@babylonjs/core/Meshes/mesh";
import { CreateLines } from "@babylonjs/core/Meshes/Builders/linesBuilder";
import { ExtrudeShape } from "@babylonjs/core/Meshes/Builders/shapeBuilder";
import { PolygonMeshBuilder } from "@babylonjs/core/Meshes/polygonMesh";
import { Vector2 } from "@babylonjs/core/Maths/math.vector";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { ElementGeometry } from "./ElementGeometry";
import { Util } from "../../utils/Util";
import { ShadowGenerator } from "@egr/wcf/modules/core/rendering/ShadowGenerator";
export class DummySafetyZone extends ElementGeometry {
    constructor(pRoomManager, pElement) {
        super(pRoomManager, pElement);
        this.mRoomElement = pElement;
        this.mRoomManager = pRoomManager;
        this.mPoints = new Array();
        this.mCutPoints = new Array();
        this.mCutted = false;
        this.mWidth = 0.1;
        this.mDepth = 0.1;
        this.mMaterial = 0;
        this.mColor = "#999999";
        this.mCenter = Vector3.Zero();
        this.mminPoint = Vector3.Zero();
        this.mmaxPoint = Vector3.Zero();
        this.mArea = 0;
        this.mPerimeter = 0;
        this.mClosedPolygon = false;
        this.mRoomElement.Params.ElementPoints = new Array();
        this.mRoomElement.Params.ElementOriginalPoints = new Array();
        this.mRoomElement.Params.material = this.mRoomElement.material;
        this.mRoomElement.Params.materialColor = this.getInitialParams().color;
    }
    getType() {
        return ("DummySafetyZone");
    }
    setMesh(pMesh) {
        this.mArea = Util.calcMeshArea(pMesh) * 0.25;
    }
    get drawnMesh() {
        return (this.mMesh2d);
    }
    getPoints() {
        return this.mPoints;
    }
    getPolygon() {
        let tpolygonPoints = [];
        for (let tP of this.mPoints) {
            let tnP = tP.add(this.mRoomElement.position);
            tpolygonPoints.push(tnP);
        }
        return (tpolygonPoints);
    }
    width() {
        return this.mWidth;
    }
    depth() {
        return this.mDepth;
    }
    material() {
        return this.mMaterial;
    }
    center() {
        return this.mCenter;
    }
    minPoint() {
        return this.mminPoint;
    }
    maxPoint() {
        return this.mmaxPoint;
    }
    showInteractors(pShow) {
        if (this.mInteractors != null)
            this.mInteractors.showInteractors(pShow);
    }
    correctDirection() {
        let tClockwise = Util._clockWise3(this.mPoints);
        if (tClockwise)
            this.mPoints.reverse();
    }
    correctDirection1() {
        for (let tPolygon of this.mCutPoints) {
            let tClockwise = Util._clockWise3(tPolygon);
            if (tClockwise)
                tPolygon.reverse();
        }
    }
    getInitialParams() {
        let tParams = {};
        tParams.width = 0.1;
        tParams.height = 0.1;
        tParams.depth = 0.1;
        tParams.floorOffset = 0.0;
        tParams.color = this.mColor;
        return (tParams);
    }
    getparent() {
        return (this.mParent);
    }
    get Area() {
        return (this.mArea);
    }
    get Perimeter() {
        return (this.mPerimeter);
    }
    getLines() {
        let tRes = new Array();
        for (let i = 0; i < this.mRoomElement.Params.ElementPoints.length - 1; i++) {
            tRes.push([this.mRoomElement.Params.ElementPoints[i], this.mRoomElement.Params.ElementPoints[i + 1]]);
        }
        return (tRes);
    }
    create2dGeometry(pParent) {
        this.mParent = pParent;
        let tLine = this.createLine(pParent);
        if (tLine != null) {
            this.mRoomElement.setMesh2d(tLine);
        }
    }
    create3dGeometry(pParent) {
        let tLine = this.createLine(pParent);
        if (tLine != null) {
            this.mRoomElement.setMesh3d(tLine);
        }
    }
    getProperties() {
        let tProperties = new Array();
        return (tProperties);
    }
    serializeIOData() {
        return (this.mRoomElement.Params);
    }
    loadIOData(pData) {
        let tParams = pData;
        let tPoints = new Array();
        for (let tEP of tParams.ElementPoints) {
            let tP = new Vector3(0, 0, 0);
            tP.x = tEP.x;
            tP.z = tEP.z;
            tPoints.push(tP);
        }
        this.setPoints(tPoints);
    }
    setPoints(pPoints, pCenter = false) {
        //this.mCutPoints = [];
        this.mPoints = [];
        for (let tPoint of pPoints) {
            let tP = new Vector3(0, 0, 0);
            tP.x = tPoint.x;
            tP.z = tPoint.z;
            this.mPoints.push(tP);
        }
        this.checkClosedPolygon();
        if (this.mClosedPolygon)
            this.correctDirection();
        this.mRoomElement.Params.ElementPoints = this.mPoints;
        this.calcCenter();
        this.calcSize();
        this.mRoomElement.setMeshMaterial1();
    }
    setCutPoints(pPoints, pCenter = false) {
        this.mCutPoints = [];
        for (let tarrPoints of pPoints) {
            let tnewPoints = new Array();
            for (let tPoint of tarrPoints) {
                let tP = new Vector3(0, 0, 0);
                tP.x = tPoint.x;
                tP.z = tPoint.z;
                tnewPoints.push(tP);
            }
            this.mCutPoints.push(tnewPoints);
        }
        if (pCenter)
            this.centerPoints(this.mCutPoints);
        this.checkClosedPolygon();
        if (this.mClosedPolygon)
            this.correctDirection1();
        this.mRoomElement.setMeshMaterial1();
    }
    centerPoints(pPoints) {
        this.mCutPoints = [];
        for (let tpointArr of pPoints) {
            let tnewArr = new Array();
            for (let tPoint of tpointArr) {
                let tnP = Util.to3d(Util.to2d(Vector3.TransformCoordinates(tPoint, this.mRoomElement.transformInverted)));
                tnewArr.push(tnP);
            }
            this.mCutPoints.push(tnewArr);
        }
    }
    checkClosedPolygon() {
        this.mClosedPolygon = Util.vectorEquals3(this.mPoints[0], this.mPoints[this.mPoints.length - 1]);
        this.mRoomElement.setClosedPolygon(this.mClosedPolygon);
    }
    calcCenter() {
        let t2dPoints = new Array();
        for (let tP of this.mPoints)
            t2dPoints.push(new Vector2(tP.x, tP.z));
        let tCenter = new Vector3(0, 0, 0);
        if (this.mPoints.length > 2)
            tCenter = Util.getPolygonCentroid(t2dPoints);
        else {
            tCenter = Vector3.Center(this.mPoints[0], this.mPoints[1]);
        }
        this.mCenter = tCenter;
    }
    calcSize() {
        if (this.mPoints.length === 0)
            return;
        let tminX = this.mPoints[0].x;
        let tminY = this.mPoints[0].z;
        let tmaxX = this.mPoints[0].x;
        let tmaxY = this.mPoints[0].z;
        for (let tPoint of this.mPoints) {
            tminX = Math.min(tPoint.x, tminX);
            tmaxX = Math.max(tPoint.x, tmaxX);
            tminY = Math.min(tPoint.z, tminY);
            tmaxY = Math.max(tPoint.z, tmaxY);
        }
        this.mWidth = tmaxX - tminX;
        this.mDepth = tmaxY - tminY;
        this.mRoomElement.setWidth(this.mWidth, false);
        this.mRoomElement.setDepth(this.mDepth, false);
        this.mminPoint = new Vector3(tminX, 0, tminY);
        this.mmaxPoint = new Vector3(tmaxX, 0, tmaxY);
        this.calcLenght();
    }
    calcLenght() {
        let tDist = 0;
        for (let i = 1; i < this.mPoints.length; i++) {
            tDist += Vector3.Distance(this.mPoints[i - 1], this.mPoints[i]);
        }
        this.mPerimeter = tDist;
        this.mRoomElement.setPerimeter(this.mPerimeter);
    }
    drawOutline(pParent) {
        //for invisible picking plane
        let tpickShape = [
            new Vector3(-0.5, 0, 0.5),
            new Vector3(-0.5, 0, -0.5),
            new Vector3(0.5, 0, -0.5),
            new Vector3(0.5, 0, 0.5),
            new Vector3(-0.5, 0, 0.5)
        ];
        if (this.mRoomElement.material === -1) {
            let tLines = CreateLines("outline", { points: this.mRoomElement.Params.ElementPoints }, this.mScene);
            tLines.color = Color3.FromHexString("#000000");
            tLines.parent = pParent;
            tLines.isPickable = false;
            tLines.renderingGroupId = 1;
            ShadowGenerator.disableMeshShadow(tLines);
            this.prepare3dMesh(tLines);
        }
        let tpolygon = ExtrudeShape("", { shape: tpickShape,
            path: this.mRoomElement.Params.ElementPoints,
            sideOrientation: Mesh.DOUBLESIDE,
            updatable: true }, this.mScene);
        tpolygon.isPickable = true;
        tpolygon.parent = pParent;
        tpolygon.visibility = 0;
        ShadowGenerator.disableMeshShadow(tpolygon);
        this.prepare3dMesh(tpolygon);
        return (tpolygon);
    }
    createLine(pParent) {
        if (this.mPoints.length === 0)
            return (null);
        if (this.mClosedPolygon) {
            let tpolyPoints = this.mRoomElement.Params.ElementPoints;
            if (this.mCutPoints.length > 0)
                tpolyPoints = this.mCutPoints[0];
            let tpoly = new PolygonMeshBuilder("", Util.to2dArray(tpolyPoints), this.mScene, MyEarcut);
            if (this.mCutPoints.length > 1) {
                for (let i = 1; i <= this.mCutPoints.length - 1; i++) {
                    let tpArr = this.mCutPoints[i];
                    tpArr.splice(tpArr.length - 1, 1);
                    tpoly.addHole(Util.to2dArray(tpArr));
                }
            }
            let tpolygon = tpoly.build(false, this.mRoomManager.ShapeHeight);
            tpolygon.name = "shape2d_line";
            tpolygon.material = this.mRoomElement.localMaterial;
            tpolygon.isPickable = true;
            tpolygon.parent = pParent;
            if (this.mRoomElement.ToolRunning) {
                tpolygon.renderingGroupId = 1;
            }
            tpolygon.material = this.mRoomElement.localMaterial;
            if (tpolygon.material != null) {
                tpolygon.material.backFaceCulling = true;
            }
            tpolygon.position.y = 0;
            ShadowGenerator.disableMeshShadow(tpolygon);
            if (this.mRoomElement.ToolRunning)
                this.drawOutline(pParent);
            this.prepare3dMesh(tpolygon);
            this.mArea = Util.calcMeshArea(tpolygon) * 0.25;
            this.mRoomElement.setArea(this.mArea);
            this.mMesh2d = tpolygon;
            return (tpolygon);
        }
        return (this.drawOutline(pParent));
    }
}
